import { useNavigate } from 'react-router-dom';
import LoadingButtonGeneral from '../../../../../components/general/buttons/loadingButtonGeneral';
import { CASES_GENERAL_INFORMATION_EDIT } from '../../../../../../routes/paths';
import EditIcon from '@mui/icons-material/Edit';
import { CasesGeneralInformationDetailActionsProps } from './props';

export const CasesGeneralInformationDetailActions = ({
    casesGeneralInformationId,
}: CasesGeneralInformationDetailActionsProps) => {
    const navigate = useNavigate();
    const textBtnStyle = {
        display: {
            xs: 'none',
            lg: 'block',
        },
    };

    const btnIconStyle = { marginRight: { xs: -1, lg: undefined } };

    return (
        <>
            <LoadingButtonGeneral
                variant="outlined"
                title="Editar"
                sx={{ mr: 1 }}
                onClick={() =>
                    navigate(
                        `${CASES_GENERAL_INFORMATION_EDIT}/${casesGeneralInformationId}`
                    )
                }
                startIcon={<EditIcon sx={btnIconStyle} />}
                textSx={textBtnStyle}
            />
        </>
    );
};
